import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import { FormikButtons } from 'components/Formik/FormikButtons'
import { FieldsExtended } from 'components/JSONForm/types'
import { Form, Formik } from 'formik'
import { FieldNames } from 'pages/Login/api/useGetActivationCodeForm'
import { EnterCodeForm } from 'pages/Login/RegisterAccount/EnterCodeForm'
import { useGetRegistrationFormByCode } from 'pages/Login/RegisterAccount/hooks/useGetRegistrationFormByCode'
import * as Yup from 'yup'

type Props = {
  onSuccess: (data: { fields: FieldsExtended<FieldNames>; personal_id_hint: any } & { code?: string }) => void
  onBack?: () => void
  disabled?: boolean
  code?: string
}

export const EnterCode = ({ onSuccess, disabled, code, onBack }: Props) => {
  const { mutate, error, variables, isLoading, isError } = useGetRegistrationFormByCode()
  const { t } = useTranslation()

  const initialValues = {
    code: code || '',
  }

  const validationSchema = Yup.object().shape({
    code: Yup.string().label(t('auth.activate_account.field.code')).notRequired().nullable(),
  })

  const onSubmit = (values: typeof initialValues) => {
    mutate({ code: values.code, onSuccess })
  }

  return (
    <Formik initialValues={initialValues} enableReinitialize validationSchema={validationSchema} onSubmit={onSubmit}>
      <Form>
        <EnterCodeForm
          disabled={disabled}
          variables={variables}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
        <Box mt={2}>
          <FormikButtons onBack={onBack} textButtonSubmit="app.next" />
        </Box>
      </Form>
    </Formik>
  )
}
